
export function isLeapYear(year) {
    return new Date(year, 1, 29).getMonth() === 1;
}

export function isValidEmail(emailAddress) {

    if (emailAddress != null) {
        let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return emailAddress.match(regex) != null;
    }

    return false;
}

export const isNotNull = (obj) => {
    return obj !== undefined && obj !== null;
}

export const isNull = (obj) => {
    return obj === undefined || obj === null;
}

export function hasErrors(errors){

    let err = 0;
    Object.keys(errors).forEach(key => {
        err += errors[key] ? 1 : 0;
    });

    return err;
}

export function isValidPhoneNumber(phoneNumber) {
    if (phoneNumber !== null) {
        const regex = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
        const valid = phoneNumber.match(regex);

        if (valid) {
            const test = phoneNumber.replaceAll("-","");
            return test.length === 10;
        }
    }

    return false;
}

export function isLengthEqualTo(text, length) {
    return (text != null && text.length === length);
}

// at some point I need to actually care about this function
export function isValidZipCode(zipCode) {

    if (zipCode != null) {

        let digits = zipCode.toString();

        if (digits.indexOf("-") > -1) {
            digits = digits.substring(0, digits.indexOf("-"));
        }

        digits = digits.split('');

        if (digits.length === 5) {
            let num = parseInt(zipCode);

            if (num > 0 && num < 99999) {
                return true;
            }
        }
    }

    return false;
}

export function isValidBirthdate(dateString) {

    if (dateString != null) {
        let values = dateString.split("/");
        let now = new Date();

        if (values.length === 3) {
            let year = parseInt(values[2]);
            let mon = parseInt(values[0]);
            let day = parseInt(values[1]);


            if (!isNaN(year) && !isNaN(mon) && !isNaN(day)) {
                if (year > 1900 && year <= now.getFullYear() &&
                    mon > 0 && mon < 13 &&
                    day > 0 && day < 32) {

                    let actualDate = new Date(year, mon - 1, day);

                    return actualDate.getMonth() === mon - 1;
                }
            }
        }
    }

    return false;
}

export function isValidCreditCardNumber(cardNumber) {
    // Remove any non-digit characters
    cardNumber = cardNumber.replace(/\D/g, '');

    // Check if the card number is empty or not a number
    if (!cardNumber || isNaN(cardNumber)) {
        return false;
    }

    // Luhn algorithm
    let sum = 0;
    let shouldDouble = false;

    for (let i = cardNumber.length - 1; i >= 0; i--) {
        let digit = parseInt(cardNumber.charAt(i), 10);

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }

    return (sum % 10 === 0);
}

export function isValidText(text, minLength, maxLength) {

    if (text != null) {

        if (minLength) {
            return text.length >= minLength;
        }

        return text.length > 0;
    }

    return false;
}

export function isMinimumLength(text) {
    return isValidText(text, 2);
}

export function isValidPassword(pass) {

    if (pass != null) {
        const regex = /^(?=.*[0-9])(?=.*[!@#$~%^&*])[a-zA-Z0-9!@#$~%^&*]{6,30}$/;

        return pass.match(regex) != null;
    }

    return false;
}

export function isNotNullOrEmpty(value) {
    return (value !== undefined && value !== null && value.length > 0);
}